(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kitrush-header"]) return;
  try {
    
const krNavigation = document.querySelector('.kr-menu');
if (krNavigation) {
  const menus = [...krNavigation.querySelectorAll(':scope > details')];
  krNavigation.addEventListener('toggle', event => {
    if (event.target.open && menus.includes(event.target)) {
      for (const menu of menus) if (menu !== event.target) menu.open = false;
    }
  }, true);
  document.addEventListener('click', event => {
    if (!krNavigation.contains(event.target)) for (const menu of menus) menu.open = false;
  });
  krNavigation.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('details[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
